export default __webpack_public_path__ + "static/media/This is how I can win you over.12988fa1.mp4";